import React from 'react';

interface States {
}

interface Props {
    text: String;
}

class Paragraph extends React.Component<Props, States> {

    state: States

    constructor(props: Props) {
        super(props)
        this.state = {}

    }

    render() {
        return (
            <div>
                <p
                    className="paragraph">
                    {this.props.text}
                </p>
            </div>
        )
    }
}

export default Paragraph;
